
import { defineComponent } from 'vue'
import Navbar from '@/components/Shared/Navbar/Navbar.vue'
import Footer from '@/components/Shared/Footer/Footer.vue'
import setLang from '@/scripts/root/setLang'
import {
  getBrowserLanguage,
  getStoredLanguage,
  normalizeLanguage,
} from '@/scripts/root/language'

export default defineComponent({
  methods: {
    setLang,
    async fetchLanguageFromHeader() {
      const storedLanguage = getStoredLanguage()
      if (storedLanguage) {
        this.setLang(storedLanguage)
        return
      }

      const browserLanguage = getBrowserLanguage()
      if (browserLanguage) {
        this.setLang(browserLanguage)
        return
      }

      try {
        const response = await fetch(window.location.href, {
          method: 'HEAD',
        })

        const customLang = normalizeLanguage(
          response.headers.get('X-Custom-Language')
        )

        if (customLang) {
          this.setLang(customLang)
        } else {
          this.setLang('en')
        }
      } catch {
        this.setLang('en')
      }
    },
  },
  created() {
    this.fetchLanguageFromHeader()
  },
  components: {
    Navbar,
    Footer,
  },
})
